import { ProgressTypeEnum } from '../../enums/progress-type/progress-type.enum';
import { ProgressPending } from './progress-pending.model';

export const progressPending: ProgressPending = {
    type: ProgressTypeEnum.PENDING,
    percent: 50,
};
